import { memo, useMemo } from 'react';
import { Heading } from '@appsumo/dorado-react';

import { FTF_SOCIAL_LINK_TYPES } from '~/constants/product';
import type { FTFLink } from '~/types/product';

import FTFHelpfulLinks from './FTFHelpfulLinks';
import FTFSocialLinks from './FTFSocialLinks';

export default memo(function FTFLinks({
  links,
}: Readonly<{ links: FTFLink[] }>) {
  const helpfulLinks = useMemo(() => {
    return links.filter((x) => !FTF_SOCIAL_LINK_TYPES.includes(x.type));
  }, [links]);

  const socialLinks = useMemo(() => {
    return links.filter((x) => FTF_SOCIAL_LINK_TYPES.includes(x.type));
  }, [links]);

  if (!links?.length) return null;

  return (
    <div className="flex flex-col gap-4 grid-in-links" data-testid="ftf-links">
      <Heading.H4 className="text-xl">Helpful links</Heading.H4>
      <FTFHelpfulLinks links={helpfulLinks} />
      <FTFSocialLinks links={socialLinks} />
    </div>
  );
});
